import { Alert, VFlow } from 'bold-ui'
import { resolveName } from 'components/form/final-form/useField'
import React, { useState } from 'react'
import { FieldArray, FieldArrayRenderProps } from 'react-final-form-arrays'
import { MetaPath } from 'util/metaPath'
import { AtendimentoProfissional } from 'view/atendimentos/types/AtendimentoProfissionalModel'

import { OrientacoesCadastroView } from './list/OrientacoesCadastroView'
import { OrientacoesTable } from './list/OrientacoesTable'
import { OrientacaoFormModel } from './types/OrientacoesModel'

interface OrientacoesViewProps {
  prontuarioId: ID
  name: MetaPath<OrientacaoFormModel>
  orientacoes: OrientacaoFormModel[]
  atendimentoProfissional: AtendimentoProfissional
}

export function OrientacoesView(props: OrientacoesViewProps) {
  const { prontuarioId, name, orientacoes, atendimentoProfissional } = props

  const [idOrientacaoEmEdicao, setIdOrientacaoEmEdicao] = useState<ID>()

  const renderFieldArray = (fieldArrayRenderProps: FieldArrayRenderProps<OrientacaoFormModel, any>) => {
    const {
      fields: { push, update, remove },
    } = fieldArrayRenderProps

    return (
      <VFlow>
        <OrientacoesCadastroView onSubmit={push} onFocus={() => setIdOrientacaoEmEdicao(null)} />
        <OrientacoesTable
          prontuarioId={prontuarioId}
          orientacoes={orientacoes}
          atendimentoProfissional={atendimentoProfissional}
          idOrientacaoEmEdicao={idOrientacaoEmEdicao}
          update={update}
          remove={remove}
          onEditClick={setIdOrientacaoEmEdicao}
        />
      </VFlow>
    )
  }

  return (
    <VFlow>
      <Alert inline type='info'>
        As orientações são informações para os cidadãos.
      </Alert>
      <FieldArray name={resolveName(name)} render={renderFieldArray} />
    </VFlow>
  )
}
